// extracted by mini-css-extract-plugin
export var aiStarIcon = "_c2-4";
export var closeButton = "_c2-6";
export var dismissButton = "_c2-3";
export var editImageWithAiContainer = "_c2-8";
export var imageUploadWrapper = "_c2-7";
export var misspelledWord = "_c2-5";
export var spellCheckContainer = "_c2-2";
export var spin = "_c2-1";
export var spinning = "_c2-0";